import { useQuery } from '@tanstack/react-query';
import * as api from 'util/api';

export default ({ limit, refetchInterval } = {}) => useQuery({
  queryKey: ['segmentation', 'runs', { limit: limit ?? null }],
  queryFn: () => api.getSegmentationRuns(limit),
  refetchInterval,
});
